import useNotification from "utils/hooks/useNotification";
import useProductApi from "../hooks/useProductApi";
import TooltipButton from "views/Documents/components/TooltipButton";
import { MdDelete } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";

interface RemoveButtonPropsTypes {
  id?: ID;
  refetch?: () => void;
}

export default function RemoveButton({ id, refetch }: RemoveButtonPropsTypes) {
  const { t } = useTranslation();
  const { deleteProduct } = useProductApi();
  const { notificationError } = useNotification();

  const confirmDelete = (id: ID) => {
    Modal.confirm({
      title: t("Delete product"),
      content: t("Are you sure about delete this product?"),
      okText: t("Yes"),
      okType: "danger",
      onOk: () => handleOk(id),
    });
  };

  const handleOk = async (id: ID) => {
    const response = await deleteProduct({
      variables: {
        id,
      },
    });

    const errors = response?.data?.deleteProduct.errors;
    notificationError(errors);

    refetch!();
  };

  return (
    <TooltipButton
      variant="delete"
      placement="top"
      handleOnClick={() => confirmDelete(id)}
      icon={<MdDelete />}
    />
  );
}
